import { render, staticRenderFns } from "./ExpenseCreateEdit.vue?vue&type=template&id=4989b4aa&scoped=true&"
import script from "./ExpenseCreateEdit.vue?vue&type=script&lang=js&"
export * from "./ExpenseCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseCreateEdit.vue?vue&type=style&index=0&id=4989b4aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4989b4aa",
  null
  
)

export default component.exports